import makeStyles from '@material-ui/styles/makeStyles'
import { DadosGerais } from 'models/Viabilidade/DadosGerais'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'
import NumberFormat from 'react-number-format'
import * as S from './index.style'

const useStyles = makeStyles(() => ({
  label: {
    fontFamily: 'IBMPlexSans-Bold'
  }
}))

const CartaoDadosGerais: React.FC<{ dadosGerais: DadosGerais }> = ({ dadosGerais }) => {
  const ehLoteamentoAberto = dadosGerais.tipoProjeto === TipoProjetoEnum.LoteamentoAberto
  const classes = useStyles()

  return (
    <>
      <S.TituloCard>DADOS GERAIS</S.TituloCard>
      <S.GridPrincipal>
        <S.GridStart>
          <S.DivCamposStart>
            <S.Label data-cy="labelNomeViabilidade" className={classes.label}>
              Nome da Viabilidade
            </S.Label>
            <S.LabelNomeViabilidade data-cy="campoNomeViabilidade" color="secondary">
              {dadosGerais.nomeViabilidade}
            </S.LabelNomeViabilidade>
          </S.DivCamposStart>
          <S.DivCamposStart>
            <S.Label data-cy="labelTipoProjeto" className={classes.label}>
              Tipo de projeto
            </S.Label>
            <S.Label data-cy="campoTipoProjeto" color="secondary">
              {dadosGerais.tipoProjeto}
            </S.Label>
          </S.DivCamposStart>
          <S.DivCamposStart>
            <S.Label data-cy="labelLinhaProduto" className={classes.label}>
              Linha de Produto
            </S.Label>
            <S.Label data-cy="campoLinhaProduto" color="secondary">
              {dadosGerais.linhaProduto}
            </S.Label>
          </S.DivCamposStart>
          {!ehLoteamentoAberto && (
            <S.DivCamposStart>
              <S.LabelNumeroCondominios className={classes.label} data-cy="labelNumeroCondominios">
                Número de Condomínio
              </S.LabelNumeroCondominios>
              <S.Label data-cy="campoNumeroCondominios" color="secondary">
                <NumberFormat
                  value={dadosGerais.numeroCondominio}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                />
              </S.Label>
            </S.DivCamposStart>
          )}
          {ehLoteamentoAberto && (
            <S.DivCamposStart>
              <S.Label className={classes.label} data-cy="labelModeloNegocio">
                Modelo de Negócio
              </S.Label>
              <S.Label data-cy="campoModeloNegocio" color="secondary">
                {dadosGerais.modeloNegocio}
              </S.Label>
            </S.DivCamposStart>
          )}
        </S.GridStart>
        <S.GridCenter>
          <S.DivCampos>
            <S.Label data-cy="labelAreaTerrenoBruta" className={classes.label}>
              Área do Terreno Bruta (m²)
            </S.Label>
            <S.LabelCenter data-cy="campoAreaTerrenoBruta" color="secondary">
              <NumberFormat
                value={dadosGerais.areaTerrenoBruta}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </S.LabelCenter>
          </S.DivCampos>
          <S.DivCampos>
            <S.Label data-cy="labelAreaTerrenoDescontar" className={classes.label}>
              Área à Descontar (m²)
            </S.Label>
            <S.LabelCenter data-cy="campoAreaTerrenoDescontar" color="secondary">
              <NumberFormat
                value={dadosGerais.areaTerrenoDescontar}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </S.LabelCenter>
          </S.DivCampos>
          <S.DivCampos>
            <S.Label data-cy="labelAreaTerrenoLiquida" className={classes.label}>
              Área do Terreno Líquida (m²)
            </S.Label>
            <S.LabelCenter data-cy="campoAreaTerrenoLiquida" color="secondary">
              <NumberFormat
                value={dadosGerais.areaTerrenoLiquida}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </S.LabelCenter>
          </S.DivCampos>
        </S.GridCenter>
        <S.GridEnd>
          <S.DivCampos>
            <S.Label data-cy="labelValorMoedaCompra" className={classes.label}>
              Valor Moeda MRV Compra (R$)
            </S.Label>
            <S.Label data-cy="campoValorMoedaCompra" color="secondary">
              <NumberFormat
                value={dadosGerais.valorMoedaMrvCompra}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </S.Label>
          </S.DivCampos>
          <S.DivCampos>
            <S.Label data-cy="labelValorMoedaAtual" className={classes.label}>
              Valor Moeda MRV Atual (R$)
            </S.Label>
            <S.Label data-cy="campoValorMoedaAtual" color="secondary">
              <NumberFormat
                value={dadosGerais.valorMoedaMrvAtual}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </S.Label>
          </S.DivCampos>
        </S.GridEnd>
      </S.GridPrincipal>
    </>
  )
}

export default CartaoDadosGerais
